import { useCallback, useEffect, useState } from 'react';

const KEY = 'gradoil-whatsapp-theme';

// Выбор темы запоминается в браузере. Если хранилище закрыто (приватное окно, запрет сайтов),
// всё работает, просто без запоминания.
const readSaved = () => {
  try {
    return window.localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch (err) {
    return 'light';
  }
};

const save = (mode) => {
  try {
    window.localStorage.setItem(KEY, mode);
  } catch (err) {
    // не страшно: тема просто не запомнится
  }
};

// Светлая или тёмная тема раздела. Пока раздел открыт, на <html> стоит data-wa-theme: по нему
// включаются переменные цветов (в том числе у окон, которые рисуются вне страницы).
export const useColorMode = () => {
  const [mode, setMode] = useState(readSaved);

  useEffect(() => {
    document.documentElement.setAttribute('data-wa-theme', mode);
    return () => document.documentElement.removeAttribute('data-wa-theme');
  }, [mode]);

  const toggle = useCallback(() => {
    setMode((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      save(next);
      return next;
    });
  }, []);

  return [mode, toggle];
};
